import { cn, ContentCardProps } from '@crabs-ai/ds-react';
import {
  PhotoFill,
  StickyNoteFill,
  AudioFile,
  ErrorFill,
} from '@crabs-ai/web-icons';
import Image, { ImageProps } from 'next/image';
import { memo, useCallback, useState } from 'react';

interface ImageWithFallbackProps extends ImageProps {
  src: string;
  alt: string;
  type?: ContentCardProps['type'];
}

/* @TODO: 디자인 시스템 적용 필요 */
function ImageWithFallback({
  src,
  alt,
  type = 'default',
  className,
  ...props
}: ImageWithFallbackProps) {
  const [error, setError] = useState(false);

  const handleError = useCallback(() => {
    setError(true);
  }, []);

  return error || !src ? (
    <div className="flex aspect-video h-full w-full items-center justify-center">
      <div className="relative">
        {type === 'default' && (
          <PhotoFill className="size-[56px] [&_path]:fill-sys-cont-neutral-disabled-light" />
        )}
        {type === 'font' && (
          <StickyNoteFill className="size-[56px] [&_path]:fill-sys-cont-neutral-disabled-light" />
        )}
        {type === 'audio' && (
          <AudioFile className="size-[56px] [&_path]:fill-sys-cont-neutral-disabled-light" />
        )}
        <ErrorFill className="absolute -top-1 -right-1 z-10 size-[20px] [&_path]:fill-sys-cont-neutral-disabled-default" />
      </div>
    </div>
  ) : (
    <Image
      src={src}
      alt={alt}
      onError={handleError}
      className={cn('object-contain', className)}
      {...props}
    />
  );
}

export default memo(ImageWithFallback);
